/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Sold_OutInputs */

const en_booking_sold_out = /** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold Out`)
};

const es_booking_sold_out = /** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agotado`)
};

const fr_booking_sold_out = /** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épuisé`)
};

const de_booking_sold_out = /** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausverkauft`)
};

const id_booking_sold_out = /** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habis Terjual`)
};

/** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */
const ja_booking_sold_out = en_booking_sold_out;

/** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */
const zh_booking_sold_out = en_booking_sold_out;

/** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */
const ar_booking_sold_out = en_booking_sold_out;

/** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */
const it_booking_sold_out = en_booking_sold_out;

/** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */
const ru_booking_sold_out = en_booking_sold_out;

/** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */
const pt_booking_sold_out = en_booking_sold_out;

/** @type {(inputs: Booking_Sold_OutInputs) => LocalizedString} */
const ko_booking_sold_out = en_booking_sold_out;

/**
* | output |
* | --- |
* | "Sold Out" |
*
* @param {Booking_Sold_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_sold_out = /** @type {((inputs?: Booking_Sold_OutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Sold_OutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_sold_out(inputs)
	if (locale === "es") return es_booking_sold_out(inputs)
	if (locale === "fr") return fr_booking_sold_out(inputs)
	if (locale === "de") return de_booking_sold_out(inputs)
	if (locale === "ja") return ja_booking_sold_out(inputs)
	if (locale === "zh") return zh_booking_sold_out(inputs)
	if (locale === "ar") return ar_booking_sold_out(inputs)
	if (locale === "id") return id_booking_sold_out(inputs)
	if (locale === "it") return it_booking_sold_out(inputs)
	if (locale === "ru") return ru_booking_sold_out(inputs)
	if (locale === "pt") return pt_booking_sold_out(inputs)
	return ko_booking_sold_out(inputs)
});